import { render, staticRenderFns } from "../../../../components/shared/contacts/ViewContactTemplate.html?vue&type=template&id=6b2b5d86&scoped=true&"
import script from "./ViewContactModal.vue?vue&type=script&lang=js&"
export * from "./ViewContactModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewContactModal.vue?vue&type=style&index=0&id=6b2b5d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b5d86",
  null
  
)

component.options.__file = "ViewContactModal.vue"
export default component.exports